import * as types from "./mutation-types";

export default {
  [types.SET_SERVICEDTO](state, payload) {
    state.servicedto = payload;
  },
};
